import React from "react";
import { Link } from "react-router-dom";

// The appointment's details screen — navigo's appointment details,
// /navigo-module?view=2&appId=<id>, the same deep link the refund dashboard
// uses. Opened in the same tab; Back returns to the case.
export const appointmentDetailsUrl = (appointmentId) => `/navigo-module?view=2&appId=${appointmentId}`;

// An appointment id that opens the appointment's details. Clicks and keys stop
// here, so it also works inside a row that expands on click.
export default function AppointmentLink({ appointmentId, children }) {
  if (!appointmentId) return children || "-";
  return (
    <Link
      className="ltr-appointment-link"
      to={appointmentDetailsUrl(appointmentId)}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {children || appointmentId}
    </Link>
  );
}
